import React from "react";
import { useSettings, resolveLogoUrl } from "@/library/lib/settings";
import { BookMarked } from "lucide-react";

const Logo = ({ size = 40, className = "", showText = true }) => {
  const s = useSettings();
  const url = resolveLogoUrl(s.logo_url);
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="logo">
      <div
        className="rounded-xl bg-white border border-slate-200 shadow-sm overflow-hidden flex items-center justify-center shrink-0"
        style={{ width: size, height: size }}
      >
        {url ? (
          <img src={url} alt="logo" className="w-full h-full object-contain" />
        ) : (
          <BookMarked className="w-1/2 h-1/2 text-brand" />
        )}
      </div>
      {showText && (
        <div className="leading-tight">
          <div className="font-heading font-extrabold text-brand-dark text-base">{s.site_name}</div>
          <div className="text-[11px] text-slate-500 font-medium">{s.school_name}</div>
        </div>
      )}
    </div>
  );
};

export default Logo;
